import { set, map, findIndex, concat } from 'lodash'
import { http, queryString } from 'utils'

// Gantt Item mutation imports.
import { SET_PROPERTY, SET_FILTER_PROPERTY, SET_GANTT_ITEM, SET_GANTT_ITEMS, ADD_GANTT_ITEM, REMOVE_GANTT_ITEM, RESET_GANTT_ITEM } from 'vx/mutations'

const initialGanttItemState = () => {
    return {
        id: null,
        name: null,
        start_date: null,
        end_date: null,
        order: 0,
        progress: 0,
        color: "",
        stage_id: null,
        client_id: null,
        confirmed: false,
        workdays: 1,
        budget_id: null,
        budget_approval_id: null,
        approved_hours: null
    }
}

// Gantt Item state.
const state = {
  ganttItem: initialGanttItemState(),
  ganttItems: [],
  filters: {
    clientId: null,
    stages1: true,
    stages2: true,
    stages3: true,
    showUnconfirmed: true
  }
}

// Gantt Item state getters.
const getters = {
  /**
   * User options for drop down.
   */
  ganttItemsSanitized: state => map(state.ganttItems, item => {
    var color = '#ffa3a3'

    if (item.stage_id == 1) {
      color = '#a6eacd'
    } else if (item.stage_id == 2) {
      color = '#a3c5ff'
    }

    return{
      id: item.id,
      text: item.name,
      start_date: item.start_date,
      end_date: item.end_date,
      index: item.order,
      progress: item.progress,
      color: color,
      stage: item.stage,
      stage_id: item.stage_id,
      client_id: item.client_id,
      parent: item.parent_id,
      project_stage: item.project_stage,
      project_stage_id: item.project_stage_id,
      confirmed: [`${item.confirmed}`],
      budget_id: item.budget_id,
      budget_approval_id: item.budget_approval_id,
      approved_hours: item.approved_hours
    }
  }),
}

// Gantt Item actions.
const actions = {

  getGanttItems ({ commit }, payload) {
    return http.get(`/project-planner/stages?${queryString(payload)}`).then(response => {
      commit(SET_GANTT_ITEMS, response.data)

      return response
    })
  },

  addGanttItem ({ commit }, payload ) {
    return http.post(`/gantt/items`, payload).then(response => {
      commit(ADD_GANTT_ITEM, response.data.data)

      return response
    })
  },

  updateProjectGanttItem ({ commit }, { id, payload }) {
    return http.put(`/project-planner/stages/${id}`, payload).then(response => {
      commit(ADD_GANTT_ITEM, response.data.data)

      return response
    })
  },

  updateGanttItem ({ commit }, { id, payload }) {
    return http.put(`/gantt/items/${id}`, payload).then(response => {
      commit(ADD_GANTT_ITEM, response.data.data)

      return response
    })
  },

  deleteGanttItem ({ commit }, id) {
    return http.delete(`/gantt/items/${id}`).then(response => {
      commit(REMOVE_GANTT_ITEM, id)

      return response
    })
  },

  setGanttItem({ commit }, payload) {
    commit(SET_GANTT_ITEM, payload)
  },

  setGanttItemProperty({ commit }, payload) {
    commit(SET_PROPERTY, payload)
  },

  setFilterProperty ({ commit }, payload) {
    commit(SET_FILTER_PROPERTY, payload)
  },

  resetGanttItem ({ commit }) {
    commit(RESET_GANTT_ITEM)
  }
}

// Gantt Item state mutations.
const mutations = {

  /**
  * Set the gantt item state.
  */
  [SET_GANTT_ITEM] (state, ganttItem) {
    state.ganttItem = ganttItem
  },

  /**
  * Set the gantt items state.
  */
  [SET_GANTT_ITEMS] (state, ganttItems) {
    state.ganttItems = ganttItems
  },

  /**
  * Add a gantt item to the state.
  */
  [ADD_GANTT_ITEM] (state, ganttItem) {
    let existingItem = findIndex(state.ganttItems, existing => existing.id === ganttItem.id)

    if (existingItem === -1) {
      state.ganttItems.push(ganttItem)
    } else {
      state.ganttItems.splice(existingItem, 1, ganttItem)
    }

  },

  /**
  * Remove gantt item
  */
  [REMOVE_GANTT_ITEM] (state, id) {
    let existingItem = findIndex(state.ganttItems, existing => existing.id === id)

    if (existingItem >= 0) {
      state.ganttItems.splice(existingItem, 1)
    }
  },

  [SET_PROPERTY] (state, { property, value, index }) {
    set(state.ganttItem, property, value)
  },

  [SET_FILTER_PROPERTY] (state, { property, value, index }) {
    set(state.filters, property, value)
  },

  /**
   * Set gantt item back to initial state
   */
  [RESET_GANTT_ITEM] (state) {
    state.ganttItem = initialGanttItemState()
  }

}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
